import React, { ChangeEvent, useState } from "react";
import { ServiceCard, ServiceCardItem } from "../ServiceContainer";
import { checkRole } from "@10x/sso";
import { LocaleUtil, StringUtil } from "@eres/core";
import Strings from "@my-dld/assets/strings";

function PropertyServices( props: { services: ServiceCard[] } ) {
	const { services } = props;
	const [ query, setQuery ] = useState<string>( "" );

	if ( services == null || services.length === 0 ) {
		return null;
	}

	const onChange = ( e: ChangeEvent<HTMLInputElement> ) => {
		const value = e.target.value;
		setQuery( value );
	};

	const nodes = <>
		{ services.filter( ( service: ServiceCard ) => {
			if ( service.userRole == undefined )
				return true;
			return checkRole( service.userRole );
		} ).filter( ( service: ServiceCard ) => {
			if ( !StringUtil.isEmptyStringOrNull( query.trim() ) )
				return LocaleUtil.getLocalValue( service.label ).toLocaleLowerCase().trim().includes( query.toLowerCase().trim() );
			return true;
		} ).map( ( value: ServiceCard, index: number ) => {
			return <ServiceCardItem
				key={ index } service={ value }
				descStringPool={ "prop_svc_description" }/>;
		} ) }
	</>;

	return <div className="card">
        <div className="card-body">
            <div className="position-relative w-100 mb-3">
                <label className="sr-only" htmlFor="mydldPropServicelist">{Strings.search}</label>
                <input type="text" id="mydldPropServicelist" className="form-control search-field-icon" onChange={onChange} placeholder={Strings.search} />
                <button className="btn txt-clear-btn" type="button"><i className="material-icons-outlined">close</i></button>
            </div>
			<div className="row my-dld-action head-card g-2">
				{ nodes }
			</div>
		</div>
	</div>;
}

export default PropertyServices;
